const SearchInput = ({ value, onChange, placeholder = "Search...", autoFocus = false }) => (
    <input
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoFocus={autoFocus}
        className="w-full max-w-xs px-3 py-2 border border-gray-300 rounded-md shadow-sm text-sm focus:outline-none box-border"
        style={{ color: 'var(--color-text)' }}
        onFocus={(e) => {
            e.target.style.borderColor = 'var(--color-primary)';
            e.target.style.boxShadow = `0 0 0 1px var(--color-primary)`;
        }}
        onBlur={(e) => {
            e.target.style.borderColor = '#d1d5db';
            e.target.style.boxShadow = 'none';
        }}
    />
);

export default SearchInput;
